import { Box, Typography } from '@mui/material';
import { SCRIVE_TYPE, SIGN_METHOD } from '@treyd-io/core/constants/auth';
import NorwayBankId from '@treyd-io/treyd-ui/assets/img/identity-verification-images/noBankid.svg';
import SwedenBankId from '@treyd-io/treyd-ui/assets/img/identity-verification-images/seBankId.svg';
import { StaticImport } from 'next/dist/shared/lib/get-img-props';
import Image from 'next/image';
import { useTranslation } from 'react-i18next';

export const BankIdDialogTitle = ({
  signingMethod,
  type,
}: {
  signingMethod: SIGN_METHOD;
  type: SCRIVE_TYPE;
}) => {
  const { t } = useTranslation();
  const titlesByType = {
    [SCRIVE_TYPE.SIGN]: {
      bankid_se: t('sign_with_bankid'),
      bankid_no: t('sign_with_bankid'),
      bankid_fi: t('sign_with_your_bank'),
      otp: t('sign_with_verification_code'),
    },
    [SCRIVE_TYPE.AUTH]: {
      bankid_se: t('confirm_with_bankid'),
      bankid_no: t('confirm_with_bankid'),
      bankid_fi: t('confirm_with_your_bank'),
      otp: t('confirm_with_verification_code'),
    },
    default: {
      bankid_se: t('confirm_with_bankid'),
      bankid_no: t('confirm_with_bankid'),
      bankid_fi: t('confirm_with_your_bank'),
      otp: t('confirm_with_verification_code'),
    },
  };

  const LOGO: Record<SIGN_METHOD, StaticImport | undefined> = {
    bankid_se: SwedenBankId,
    bankid_no: NorwayBankId,
    bankid_fi: undefined,
    otp: undefined,
  };
  const textValue =
    titlesByType?.[type][signingMethod] || titlesByType.default[signingMethod];
  const icon = LOGO?.[signingMethod || 'otp'];
  return (
    <Box display="flex" alignItems="center">
      {icon && (
        <Image
          style={{ marginInlineEnd: '16px' }}
          src={icon}
          alt="bankid-icon"
        />
      )}
      <Typography variant="h5">{textValue}</Typography>
    </Box>
  );
};
